import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

interface PasswordRequirementsProps {
  password: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
  const requirements = [
    {
      label: 'At least 8 characters',
      test: (pass: string) => pass.length >= 8,
    },
    {
      label: 'One uppercase letter',
      test: (pass: string) => /[A-Z]/.test(pass),
    },
    {
      label: 'One lowercase letter',
      test: (pass: string) => /[a-z]/.test(pass),
    },
    {
      label: 'One number',
      test: (pass: string) => /[0-9]/.test(pass),
    },
    {
      label: 'One special character (!@#$%^&*)',
      test: (pass: string) => /[!@#$%^&*]/.test(pass),
    },
  ];

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 1, display: 'block' }}>
        Password Requirements:
      </Typography>
      <Stack spacing={1}>
        {requirements.map((req, index) => {
          const isMet = req.test(password);
          return (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {isMet ? (
                <CheckCircleOutlineIcon fontSize="small" sx={{ color: '#4caf50' }} />
              ) : (
                <CancelOutlinedIcon fontSize="small" sx={{ color: '#f44336' }} />
              )}
              <Typography 
                variant="body2" 
                sx={{ 
                  color: isMet ? '#81c784' : '#e57373',
                  fontSize: '0.85rem'
                }}
              >
                {req.label}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default PasswordRequirements;
